export default __webpack_public_path__ + "static/media/Old_Left.6015a430.dwg";